var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPbRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pb-rename_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 998",
    transform: "translate(1592 100)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1592 -100)",
    clipPath: "url(#pb-rename_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11803",
    d: "M1614.362 104.992a.66.66 0 00-.653.167l-15.854 15.858a.66.66 0 00-.186.377l-.692 4.892a.66.66 0 00.74.742l4.9-.693a.659.659 0 00.371-.189l15.854-15.858a.659.659 0 00-.007-.93l-4.188-4.194a.659.659 0 00-.285-.172zm-.186 1.571l3.264 3.264-15.227 15.227-3.806.548.539-3.8 15.229-15.236z"
  }))));
}

export default __webpack_public_path__ + "7f3a1bf59f4f5ec222f2dfdb5f119d15.svg";
export { SvgPbRename as ReactComponent };